import React from 'react';
import { Avatar, Group, Text } from '@mantine/core';
import { Species } from '../../../../types/gql-op-types';
import DogPlaceholder from '../../../../assets/images/dog_placeholder.png';
import CatPlaceholder from '../../../../assets/images/cat_placeholder.png';
import { Image } from '../../../../components/Image';

export function SimplePetDisplay({
  petName,
  petSpecies,
  avatarUrl,
}: {
  petName: string;
  petSpecies?: Species | null;
  avatarUrl?: string;
}) {
  const avatarPlaceholder = petSpecies === Species.CAT ? CatPlaceholder : DogPlaceholder;

  return (
    <Group spacing={8}>
      <Avatar src={avatarUrl ?? avatarPlaceholder} radius="xl" size={24}>
        <Image image={{ type: 'image', url: avatarPlaceholder }} />
      </Avatar>
      <Text color="type-light-primary" fw={600}>
        {petName}
      </Text>
    </Group>
  );
}
